'use strict';

/**
 * Converts a value or an array of values into a non-nullable array.
 * If the input is an array, it removes any `null` or `undefined` values.
 * If the input is not an array, it wraps it in an array and removes `null` or `undefined` values.
 *
 * @template T - The type of the values in the array.
 * @param {MaybeArrayOf<T>} x - The value or array of values to convert.
 * @returns {T[]} - The resulting non-nullable array.
 */ function makeNonNullableArray(x) {
    const maybeXArr = Array.isArray(x) ? x : [
        x
    ];
    return maybeXArr.filter((v)=>!!v);
}

module.exports = makeNonNullableArray;
